import { render } from "./WaveComponent.vue?vue&type=template&id=748ac1ff&scoped=true"
import script from "./WaveComponent.vue?vue&type=script&lang=js"
export * from "./WaveComponent.vue?vue&type=script&lang=js"

import "./WaveComponent.vue?vue&type=style&index=0&id=748ac1ff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-748ac1ff"]])

export default __exports__